import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthConfigModule } from '@shared/auth/auth-config.module';
import { AppRoutingModule } from './app/app-routing.module';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FeatureFlagService } from '@services/feature-flag.service';
import { APP_BASE_HREF, PlatformLocation, registerLocaleData } from '@angular/common';
import { ConfigService } from '@shared/services/config.service';
import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import Bolt from '@nationwide-bolt/bundle-core';
import { init as initFullStory } from '@fullstory/browser';
import { provideMarkdown } from 'ngx-markdown';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';

registerLocaleData(en);

const FULLSTORY_ORG = 'KJMMK';

initFullStory({
  orgId: FULLSTORY_ORG,
  devMode: false,
});

(function (src) {
  const body = document.getElementsByTagName('head')[0];
  const _js = document.createElement('script');
  _js.type = 'text/javascript';
  _js.src = src;
  _js.defer = true;
  body.appendChild(_js);
})(environment.analyticsTagSrc);

function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

Bolt.initialize().then(() =>
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(BrowserModule, AppRoutingModule, AuthConfigModule, NzLayoutModule, ...environment.imports),
      provideAppInitializer(() => {
        const initializerFn = (
          (configService: ConfigService) => () =>
            configService.load()
        )(inject(ConfigService));
        return initializerFn();
      }),
      {
        provide: APP_BASE_HREF,
        useFactory: getBaseHref,
        deps: [PlatformLocation],
      },
      FeatureFlagService,
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      provideMarkdown(),
      provideNzI18n(en_US),
      importProvidersFrom(FormsModule),
      provideAnimationsAsync(),
      provideHttpClient(),
      provideRouter([], withComponentInputBinding()),
    ],
  }).catch((err) => console.error(err)),
);
